import UltMeta, { Meta } from "@/meta/UltMeta/index";

/**
 * 标签类型
 */
class TypeState extends UltMeta {
    PRODUCT_TYPE = new Meta(1, "品类");
    Information = new Meta(2, "资讯");
    SAND_ACADEMY = new Meta(3, "砂石学院");
}
export const TYPE_STATE = new TypeState();

/**
 * 操作类型
 */
class OperateType extends UltMeta {
    DELETE = new Meta(1, "删除");
    ADD = new Meta(2, "新增");
    UPDATE = new Meta(3, "修改");
}
export const OPERATE_TYPE = new OperateType();
